import "./birdlife.css";
import "../about/about.css";

import React from "react";

import { BIRDLIFE } from "../../data/content";
import PageMeta from "../general/PageMeta";
import PageTitle from "../general/PageTitle";
import YouTube from "../general/YouTube";

const CaptionedPhoto = ({ image }) => (
  <figure className={"captioned-photo"}>
    <img
      src={image.src}
      alt={image.alt}
      loading={"lazy"}
      width={892}
      height={600}
    />
    <figcaption className={"photo-caption"}>{image.caption}</figcaption>
  </figure>
);

const BirdLife = () => {
  return (
    <div className={"page"}>
      <PageMeta
        title={"BirdLife South Africa"}
        description={"The Charles Greig Gallery proudly supports BirdLife South Africa's Albatross Task Force, which works to conserve at least 24 albatross and petrel species."}
      />
      <PageTitle>{BIRDLIFE.PAGE_TITLE}</PageTitle>

      <div className={"container"}>
        <section className={"title-box"}>
          <h2 className={"section-title"}>{BIRDLIFE.ABOUT_TITLE}</h2>
          <p className={"body-text is-justified birdlife-about"}>{BIRDLIFE.ABOUT}</p>
        </section>

        <section className={"split-row"}>
          <div className={"split-text no-dash"}>
            <h2 className={"section-title is-left"}>{BIRDLIFE.ATF_TITLE}</h2>
            <p className={"body-text is-justified"}>{BIRDLIFE.ATF}</p>
          </div>
          <YouTube
            id={BIRDLIFE.YOUTUBE_ID}
            title={BIRDLIFE.YOUTUBE_TITLE}
          />
        </section>

        <section className={"split-row is-reversed"}>
          <div className={"split-text no-dash"}>
            <h2 className={"section-title is-left"}>{BIRDLIFE.GOALS_TITLE}</h2>
            <p className={"body-text is-justified"}>{BIRDLIFE.GOALS_INTRO}</p>
            <ul className={"birdlife-goals"}>
              {BIRDLIFE.GOALS.map((goal) => (
                <li
                  key={goal}
                  className={"body-text is-justified"}
                >
                  {goal}
                </li>
              ))}
            </ul>
          </div>
          <CaptionedPhoto image={BIRDLIFE.TEAM_IMAGE} />
        </section>

        <section className={"birdlife-support"}>
          <p className={"birdlife-support-text"}>{BIRDLIFE.SUPPORT}</p>
          <CaptionedPhoto image={BIRDLIFE.ALBATROSS_IMAGE} />
        </section>
      </div>
    </div>
  );
};

export default BirdLife;
